import { render, staticRenderFns } from "./saleRecord_list.vue?vue&type=template&id=1da1ccf1&scoped=true&"
import script from "./saleRecord_list.vue?vue&type=script&lang=js&"
export * from "./saleRecord_list.vue?vue&type=script&lang=js&"
import style0 from "./saleRecord_list.vue?vue&type=style&index=0&id=1da1ccf1&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1da1ccf1",
  null
  
)

export default component.exports